// extracted by mini-css-extract-plugin
export default {"homeCatalogueCont":"Catalogue_homeCatalogueCont__iseG5","sectionHeading":"Catalogue_sectionHeading__khTJX"};